'use client';

import MediaContent from '@/app/(with-metadata)/(main)/media/MediaContent';
import Hero from '../Hero';
import { useConfig } from '@/app/contexts/ConfigContext';
import { CONTENT_MEDIA_TAG_ALL, SERVICE_TYPES } from '@/helpers/enums';

export default function MediaAllPage() {
  const { config } = useConfig();

  let tag;

  switch (config.serviceType) {
    case SERVICE_TYPES.MEDITATION:
      tag = CONTENT_MEDIA_TAG_ALL.MEDITATION;
      break;
    case SERVICE_TYPES.ASTROLOGY:
    case SERVICE_TYPES.LOVE:
      tag = CONTENT_MEDIA_TAG_ALL.PODCAST;
      break;

    default:
      tag = undefined;
      break;
  }

  return (
    <main className='max-w-[1920px] mx-auto overflow-hidden'>
      <Hero />
      <MediaContent tag={tag} />
    </main>
  );
}
